import * as React from 'react';
import { ControlFacet } from '../models/controls/ControlFacet';
import { IWithWizardInjectedProps } from '../components/decorators/withWizard';
import { defaultRenderComponentOption } from '../components/controls/defaultRenderComponentControlOption';
import { IComponentAsProps } from '@uifabric/utilities/lib/IComponentAs';

/**
 * @public
 */
export type IRenameWizardProps = IWithWizardInjectedProps & {
  onRename: (props: { name: string }) => Promise<void>;
  itemKey: string;
  oldName: string;
  isAvailable: boolean;
  validator?: (name: string) => string | undefined;
  lockedWarningMessage?: string;
  title?: string;
  fileExtensionText?: string;
};

/**
 * @public
 */
export interface IRenameActionControlProps {
  itemKey: string;
}

/**
 * @public
 */
export interface IRenameActionControlOverrides {
  isAvailable: boolean;
  validator?: (name: string) => string | undefined;
  lockedWarningMessage?: string;
  title?: string;
  renameWizard: React.ComponentType<IComponentAsProps<IRenameWizardProps>>;
}

/**
 * @public
 */
export const renameActionControl: ControlFacet<IRenameActionControlProps, IRenameActionControlOverrides> =
  new ControlFacet<IRenameActionControlProps, IRenameActionControlOverrides>('renameActionControl', {
    renameWizard: defaultRenderComponentOption()
  });
